import React, { useState, useEffect, useCallback } from 'react'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import MasterSelect from '../MasterSelect'

const GrantWrap = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-flow: column;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #666;
`
const FlexStyle = styled.div`
  display:flex;
  width: 100vw;
  height: 80vh;
  background-color:#666;
  background-repeat: no-repeat;
  background-size: 20%;
  background-position: 5% top;
  color:#FFF;
`

const Grant = (props) => {

    useEffect(() => {
        document.title = '権限マスタ管理 | Core Time Cloud'

        const wap = document.getElementById('GrantWrap')
        //ImagesLoaded(wap, { background: true }, () => {
          //wap.style.display = 'flex'
        //})
      }, [])

    return (
        // <GrantWrap id='GrantWrap'>
        // <FlexStyle>
        //     <div className='contents'>権限マスタ管理</div>
        // </FlexStyle>
        // </GrantWrap>
        <div id='GrantWrap'>
        <div style={{display: 'flex'}}>
            <h3 className='title' style={{padding:'1vw',lineHeight: '32px',fontSize:'24px'}}>{'権限マスタ管理'}</h3>
        </div>
        <MasterSelect/>
        </div>
    )
}

export default Grant
